import { toast } from "react-toastify";
import api from "./api/api";

interface AuthPayload {
  email: string;
  password: string;
}

const UsersService = {
  auth: async (payload: AuthPayload) => {
    try {
      const res = await api.post(`/auth`, payload, {
        headers: { withoutAuth: true },
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  forgotPassword: ({ email }: { email: string }) => {
    return api.post(`/esqueci-minha-senha/enviar-token`, { email });
  },
  changePasswordWithToken: ({
    email,
    token,
    password,
    passwordConfirmation,
  }: {
    email: string;
    token: string;
    password: string;
    passwordConfirmation: string;
  }) => {
    return api.post(`/esqueci-minha-senha/cadastrar-senha`, {
      email,
      token,
      password,
      passwordConfirmation,
    });
  },
  newPassword: ({
    email,
    oldPassword,
    password,
    passwordConfirmation,
  }: {
    email: string;
    oldPassword: string;
    password: string;
    passwordConfirmation: string;
  }) => {
    return api.post(`/users/nova-senha-de-novo-usuario`, {
      email,
      oldPassword,
      password,
      passwordConfirmation,
    });
  },
  me: async () => {
    try {
      const res = await api.get(`/me`);
      return res;
    } catch (error: any) {
      localStorage.removeItem("token");
      toast.success("Deslogado com Sucesso!");
      return error.response;
    }
  },
  aniversariantes: async (
    mes: any,
    page: any,
    perPage: any,
    typeUser: any,
    agency_id: any,
    cargo_i: any,
    area_id: any,
    regiao_id: any,
    representante_id: any,
    representado_id: any
  ) => {
    try {
      const params: any = {
        page,
        perPage,
        ...(mes && { month: mes }),
        ...(typeUser && { type: typeUser }),
        ...(agency_id && { agencia_id: agency_id }),
        ...(cargo_i && { cargo_id: cargo_i }),
        ...(area_id && { area_id }),
        ...(regiao_id && { uf_id: regiao_id }),
        ...(representante_id && { representante_id }),
        ...(representado_id && { representado_id }),
      };

      const res = await api.get(`/users/aniversariantes`, { params });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  editMyUser: async (payload: any) => {
    try {
      const res = await api.put(`users/edit`, payload);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  cadastrarSenhaNovoUsuario: async (
    payload:
      | FormData
      | {
          email: string;
          password: string;
          passwordConfirmation: string;
        }
  ) => {
    try {
      const res = await api.post(`/users/nova-senha-de-novo-usuario`, payload, {
        headers:
          payload instanceof FormData
            ? { "Content-Type": "multipart/form-data" }
            : undefined,
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  finalizarCadastro: async ({
    email,
    password,
    passwordConfirmation,
  }: {
    email: string;
    password: string;
    passwordConfirmation: string;
  }) => {
    try {
      const res = await api.post(
        `/users/finalizar-cadastro`,
        {
          email,
          password,
          passwordConfirmation,
        },
        {
          headers: { withoutAuth: true },
        }
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default UsersService;
